import { render, staticRenderFns } from "./CustomsSettings.vue?vue&type=template&id=76f995eb&"
import script from "./CustomsSettings.vue?vue&type=script&lang=js&"
export * from "./CustomsSettings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports